import React from "react";

const PopInNavIcon = () => {
  return (
    <>
    <svg width="30" height="30" viewBox="0 0 30 30">
        <g id="Group_184" data-name="Group 184" transform="translate(-38 -218)">
          <rect
            id="Rectangle_20"
            data-name="Rectangle 20"
            width="30"
            height="6"
            rx="3"
            transform="translate(38 218)"
          />
          <rect
            id="Rectangle_23"
            data-name="Rectangle 23"
            width="30"
            height="6"
            rx="3"
            transform="translate(38 242)"
          />
          <rect
            id="Rectangle_21"
            data-name="Rectangle 21"
            width="16"
            height="6"
            rx="3"
            transform="translate(38 231)"
          />
          <rect
            id="Rectangle_22"
            data-name="Rectangle 22"
            width="12"
            height="6"
            rx="3"
            transform="translate(56 231)"
          />
        </g>
      </svg>
      
    </>
  );
};

export default PopInNavIcon;
